<template>
  <transition name="popup-transition">
    <div v-if="showDeletePopup" class="popup">
      <div class="popup-overlay"></div>
      <div class="popup-content">
        <div class="container-fluid" style="padding: 20px">
          <div>Are you sure you want to delete this item?</div>
          <div class="row justify-content-center mt-3">
            <div class="col-auto">
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="confirmDelete"
                >Delete
                </button>
            </div>
            <div class="col-auto">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closePopup"
                >Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
    props: {
        showDeletePopup: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        confirmDelete() {
            this.$emit("confirm-delete");
        },
        closePopup() {
            this.$emit("close-popup");
        },
    },
};
</script>

<style scoped>
.popup {
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    border: black;
}

.popup-content {
    background-color: #fefefe;
    padding: 5px;
    border: 1px solid #888;
    z-index: 999;
    border-radius: 10px;
    max-width: 70%;
    position: fixed;
    top: 100px;
    width: 60%;
}

.popup-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.5;
    z-index: 900;
}
</style>
